import { getCompaniesDepreciation } from "../utils/WordExportUtils";
import { addTableSpace, generateTable } from "./utils";

export const generateLeasesTable = () => {
  const data = getCompaniesDepreciation();

  const columns = [
    {
      title: "Company Name",
      metric: "company_name",
      color: "blue",
    },
    {
      title: "Currency",
      metric: "currency",
      color: "blue",
    },
    {
      title:
        "Right-of-use lease finance expense in respect of leases that would be treated as finance leases",
      color: "blue",
    },
    {
      title:
        "Amount of SP3/91 deduction claimed in respect of right-of-use leases that would be treated as finance leases",
      metric: "relief_lease",
      color: "blue",
      type: "number",
    },
  ];

  const table = generateTable(data, columns, ["relief_lease"]);

  return [...(table ? [addTableSpace(100), table] : [])];
};
